export default new class MainSection {
    constructor() {
        this.mainSection = '[data-main-section]';

        if (!$(this.mainSection).length) return;

        this.smoothScrollLink = '[data-smooth-scroll-link]';
        this.imgBackground = '[data-main-background]';

        this.eventsHandler();
        this.setMainBackground();
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.smoothScrollLink, e => {
            this.smoothScroll($(e.currentTarget))
        })
    }

    smoothScroll($btn) {
        let sectionID = $btn.data('smooth-scroll-link'),
            offsetTop = $(sectionID).offset().top;

        $('html, body').animate({
            scrollTop: offsetTop
        }, 900)
    }

    setMainBackground() {
        let path = $(this.imgBackground).attr('src');

        $(this.mainSection).css({
            backgroundImage: `url(${path})`
        })
    }
}